export enum HoleUnitTypes {
  Driller = 'DRILLER',
  Piler = 'PILER'
}